import Alert from "./alert";

export default function form(formElement) {
    Validator.useLang('es');

    return {
        serialize: () => {
            const data = new FormData(formElement);
            const dataObject = {};
            const processedFields = new Set();

            data.forEach((value, name) => {
                // Skip if already processed (for checkboxes with hidden inputs)
                if (processedFields.has(name)) {
                    return;
                }

                const inputElement = formElement.querySelector(`[name="${name}"]`);
                
                // Handle checkboxes specially
                if (inputElement && inputElement.type === 'checkbox') {
                    dataObject[name] = inputElement.checked;
                    processedFields.add(name);
                    return;
                }

                if (inputElement && inputElement.hasAttribute('data-numeric')) {
                    let decimals = parseInt(inputElement.getAttribute('data-decimals')) || 0;
                    value = new Str(value).parseDecimal(decimals);

                    if (value === NaN || value === 'NaN')
                        value = null;
                }

                dataObject[name] = value;
            });
            return dataObject;
        },
        validate: (formData, rules, messages = {}) => {

            var validator = new Validator(formData, rules, messages);
            validator.check();

            $('[data-valmsg-for]').text('');

            if (validator.fails()) {
                console.log(validator.errors.all());
                mostrarValidacionModelo(validator.errors.all())
            }

            return validator.passes();
        },
        submit: (dataObject, contentType = 'application/x-www-form-urlencoded') => {
            return new Promise(async (resolve, reject) => {
                dataObject = dataObject ? dataObject : this.serialize();

                try {
                    loading().show();

                    const response = await http().post(formElement.action, dataObject, { headers: { 'Content-Type': contentType } });

                    Alert.success(_t("master.guardado_exitoso"));
                    resolve(response);

                } catch (error) {

                    if (error.code === "ERR_BAD_REQUEST" && error.response.data?.errors)
                        mostrarValidacionModelo(error.response.data.errors);
                    else if (error.code === 'ERR_NETWORK')
                        Alert.error(error.message);
                    else
                        Alert.error(error.response.data?.message || _t("master.ocurrio_un_error"));

                    reject(error);

                } finally {
                    loading().hide();
                }
            });
        }
    };
}

function mostrarValidacionModelo(errors) {

    for (let key in errors) {
        if (errors.hasOwnProperty(key)) {
            let fieldName = key;
            let errorMessage = errors[key][0];
            mostrarErrorDeValidacion(fieldName, errorMessage || "Invalid");
        }
    }
}

function mostrarErrorDeValidacion(fieldName, errorMessage) {
    const validationElement = $('[data-valmsg-for="' + fieldName + '"]');
    if (validationElement.length) {
        validationElement.text(errorMessage).removeClass('field-validation-valid').addClass('field-validation-error');
    }
    else {
        Alert.warning(`${fieldName}: ${errorMessage}`);
    }
}
